var map = {
	"./def.svg": "f941",
	"./dxicons.ttf": "ced3",
	"./dxicons.woff": "02a5",
	"./dxicons.woff2": "8adc",
	"./dxiconsios.ttf": "856d",
	"./dxiconsios.woff": "42f1",
	"./group-logo.svg": "ef58",
	"./icon-back.svg": "6f03",
	"./icon-bind.svg": "7e96",
	"./icon-calendar.svg": "0979",
	"./icon-cancel.svg": "2681e",
	"./icon-checkmark.svg": "7a12",
	"./icon-chinese.svg": "8c7f",
	"./icon-close.svg": "58ef",
	"./icon-copy-default.svg": "732a",
	"./icon-copy-doc.svg": "9ff6",
	"./icon-customs.svg": "48c2",
	"./icon-doc.svg": "f401",
	"./icon-download.svg": "5f35",
	"./icon-drag-n-drop-default.svg": "3b6d",
	"./icon-dropdowneditor.svg": "e232",
	"./icon-dropupeditor.svg": "b2c9",
	"./icon-edit-default.svg": "fc78",
	"./icon-english.svg": "88ea",
	"./icon-extra.svg": "630e",
	"./icon-eyeclose.svg": "2009",
	"./icon-eyeopen.svg": "4b6c",
	"./icon-fields.svg": "3e2e",
	"./icon-info.svg": "7d57",
	"./icon-login.svg": "2b14",
	"./icon-logo.svg": "c722",
	"./icon-mention.svg": "ba73",
	"./icon-place.svg": "343f",
	"./icon-port.svg": "813b",
	"./icon-refresh.svg": "f14b",
	"./icon-russian.svg": "f97c",
	"./icon-ship.svg": "d667",
	"./icon-storage.svg": "80b2",
	"./icon-support.svg": "f3f9",
	"./icon-train.svg": "49ac",
	"./icon-transport.svg": "efc2",
	"./icon-trash-default.svg": "8793",
	"./icon-user.svg": "7331"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5503";